import React from 'react';
import PropTypes from 'prop-types';
import ErrorDisplay from '../shared/errorDisplay';

const NameField = props => {
  const handleChange = event => {
    props.addTempUserName(event.target.value);
  };

  const isError = props.error.indexOf('(name-') !== -1;
  const classes = isError ? 'invalid' : '';

  return (
    <div className="inpt name-inpt">
      <p className="desc">{props.translations['enter-name']}</p>
      <span className="req">{props.translations.required}</span>
      {props.error.indexOf('(name-required)') !== -1 && (
        <ErrorDisplay errorMessage={props.translations['this-is-required']} />
      )}
      {/* eslint-disable jsx-a11y/label-has-for */}
      <label htmlFor="comment-name">{props.translations.name}</label>
      {/* eslint-enable jsx-a11y/label-has-for */}
      <div>
        <input
          id="comment-name"
          className={classes}
          type="text"
          placeholder={props.translations.name}
          maxLength={props.maxlength}
          name="name"
          value={props.name}
          onChange={handleChange}
          required
        />
      </div>
    </div>
  );
};

NameField.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  maxlength: PropTypes.number.isRequired,
  addTempUserName: PropTypes.func.isRequired,
  error: PropTypes.string,
  name: PropTypes.string,
};

NameField.defaultProps = {
  error: '',
  name: '',
};

export default NameField;
